import React from 'react';
import './Chapters.scss';

function Chapter8() {
  return (
    <section className="chapter">
      <h3 className="chapter__title">The Future of Food Technology</h3>
      <p className="chapter__paragraph">
        FareShare has created an impressive and impactful nationwide food redistribution network.
        But Lucy Danger is not ready to rest on those laurels. “The amount of food we can
        redistribute today is a really positive increase from where we were a few years ago, but
        we’re still just using a small fraction of the surplus food in the UK supply chain,” she
        says.
      </p>
      <p className="chapter__paragraph">
        The intelligence gained from Peak’s AI applications will give FareShare GM new insights and
        speed up information flows, helping FareShare GM to get better at forecasting and matching
        supply and demand.
      </p>
      <p className="chapter__paragraph">
        “The goal is to smooth out and accelerate the cycle of turning around food donations,”
        Danger says. “Our priority is to get the food moving faster so that our community partners
        can reduce hunger further and help more people in need.”
      </p>
      <p className="chapter__paragraph">
        Advances in cloud technology are enabling the applications and insights for a wide variety
        of organizations—from non-profits like FareShare to major corporations that manage
        operations across the globe—to improve efficiency, lower costs, and better serve customers.
      </p>
    </section>
  );
}

export default Chapter8;
